import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from 'moment';
import { Map } from 'immutable';
import { ISO_8601_MS_RESOLUTION, getIdFromEntityKey, isActiveCallKey, isExtensionKey } from 'flow/utils';
import { convertNumberToE164, formatE164NumberToTopFriendly, ActiveCallDirections } from 'flow/utils/call-utils';
import { getStandardProfileDescriptionInUserLanguage } from 'flow/utils/profile-utils';
import { i18next } from 'flow/configure-locale';
import appConfig from 'app-config';
import Actions from 'flow/actions';
import { addOrUpdateActiveCall, addOrUpdateActiveProfile, removeActiveCall } from 'flow/actions/extension-actions';
import { fetchQueueCallRecordsUnhandled } from 'flow/actions/PbxActions';
import { onQueueCallEnded, receiveQueueMemberUpdate, receiveQueueProfile } from 'flow/actions/pbx-actions';
import { getOwnFixedNumber, getOwnMobileNumber, getOwnExtensionKey, getActiveProfileForQueue } from 'flow/selectors/selectors';
import { callHungup, callAnswered, handleNewCall, redecorateCall, isBagVariableChanged } from 'flow/actions/cti-actions';
import { isAppCti } from 'flow/utils/app-utils';
import { topEventHasChannelOfTypeCentionOmni, getBagVariableCentionMessageFromTopMessage } from 'flow/utils/omnichannel-utils';
import { getRingingCall, getLocalCallSessions, getLocalActiveCalls } from 'flow/selectors/call-selectors';
import { loggedInUserHasOmnichannelFeature } from 'flow/selectors/extension-selectors';
import { addTopLogEntry, addUserPhoneLogEntry } from 'flow/utils/browser-utils';
import { resolveTransferPending, unholdAllSessions } from 'flow/actions/phone-actions';
import { tryAutoOpenWidgetUrls } from 'flow/actions/run-url-actions';
import { removeOmnichannelDeeplink } from 'flow/actions/omnichannel-actions';
import { shouldAutoOpenCallWidgetUrls, shouldAutoOpenCallWidgetUrlsForPickedQueueCall } from 'flow/utils/run-url-utils';
import { mergeIntoConference, hangupCall as topHangupCall, pickupQueueCall, pickupCall } from 'flow/api-clients/top-client';
import { selectActiveMeetingCallId } from 'flow/selectors/meeting-selectors';
import { endMeeting } from 'flow/actions/meeting-actions';
import { isQueueKey } from 'flow/utils';
import { ctiTraceLog } from 'flow/utils/cti-call-log-utils';
import { selectExtensionActiveProfile } from 'flow/selectors/ExtensionSelectors';
import { base64DecodeUTF8 } from 'flow/utils/transcode-utils';
import { getDataFromBagInTopMessage } from 'flow/utils/ticket-utils';
import { selectQueueFavorites } from 'flow/selectors/favorite-selectors';
import { selectMissedCallsWidgetIsMounted } from 'flow/selectors/app-selectors';
import { selectWaitingQueueCallForCaller, selectWaitingQueueItem } from 'flow/selectors/queue-selectors';
import { handleAutoCoListenAlphaFeatureOnCallEstablished } from 'flow/components/central-switch/central-switch-widgets/CoListeningAutoWidgetAlpha/CoListeningAlphaHelper';
import { setTranscriptionInProgress } from 'flow/actions/RecordedCallsActions';
import { sweepCompanionMuteState } from 'flow/companion/companion-actions';
export var receiveSyncStart = {
  type: Actions.RESULT_TOP_SYNC_START
};
export var receiveSyncStop = {
  type: Actions.RESULT_TOP_SYNC_STOP
};

// Top sends this instead of a number in any caller-id field it has no number
// for. It must never be stored as a number: it reaches the call UI
// ('getNumberOfOtherPerson') and the '%NUMBER%'/'%CALLER%' call widget URLs.
var UNKNOWN_CALLER_ID = '<unknown>';

// Make sure the operator note gets decoded correctly and spaces gets parsed as spaces and not '+'
var decodeOperatorNote = function decodeOperatorNote(operatorNote) {
  var polishedString = operatorNote.replace(/\+/g, '%20');
  return decodeURIComponent(polishedString);
};

// When we change our profile we get our new active profile from home with plusId first.
// This function prevents the top data from removing the correct plusId
var calculatePlusId = function calculatePlusId(state, entityKey, newProfileKey) {
  if (!newProfileKey) return null;
  var previousProfile = function () {
    if (isExtensionKey(entityKey)) {
      return selectExtensionActiveProfile(state, entityKey);
    } else if (isQueueKey(entityKey)) {
      return getActiveProfileForQueue(state, entityKey);
    } else return null;
  }();
  if (!previousProfile || previousProfile.isEmpty()) return null;
  var newProfileIsSameAsPrevious = previousProfile.get('key') === newProfileKey;
  if (newProfileIsSameAsPrevious) {
    return previousProfile.get('plusId');
  } else return null;
};
export var receiveActiveProfile = function receiveActiveProfile(msg) {
  return function (dispatch, getState) {
    var extensionKey = function () {
      if (msg.Event === 'Redirects') {
        var _getState = getState(),
          top = _getState.top;
        return top.getIn(['anumberToEntityKey', msg.Extension]);
      } else if (msg.Event === 'Extension') {
        return msg.EntityKey;
      } else {
        return null;
      }
    }();
    var queueKey = function () {
      if (msg.Event === 'Redirects') {
        var entityKey = msg.EntityKey;
        var isQueue = isQueueKey(entityKey);
        if (isQueue) {
          return entityKey;
        }
      }
      return null;
    }();
    var profileKey = msg.ActiveProfileId || null;
    if (extensionKey) {
      var profileDescription = getStandardProfileDescriptionInUserLanguage(msg.ActiveProfile, i18next);

      // Dispatch action for setting the active profile
      var profile = {
        key: profileKey,
        plusId: calculatePlusId(getState(), extensionKey, profileKey),
        available: msg.Available === 'true',
        description: profileDescription,
        operatorNote: decodeOperatorNote(msg.Operatornote),
        activeUntil: msg.ProfileUntilISO ? moment(msg.ProfileUntilISO).format(ISO_8601_MS_RESOLUTION) : null,
        lyncOnThePhone: msg.LyncOnThePhone ? true : false
      };
      dispatch(addOrUpdateActiveProfile(extensionKey, profile));
    }
    if (queueKey) {
      var _profileDescription = getStandardProfileDescriptionInUserLanguage(msg.ActiveProfile, i18next);
      var _profile = {
        key: profileKey,
        plusId: calculatePlusId(getState(), queueKey, profileKey),
        description: _profileDescription,
        available: msg.Available === 'true',
        active: true,
        activeUntil: msg.ProfileUntil ? msg.ProfileUntil : null
      };
      dispatch(receiveQueueProfile(queueKey, _profile));
    }
  };
};
export var recieveNewMexChannelsOnSync = function recieveNewMexChannelsOnSync(msg) {
  return function (dispatch) {
    var mexChannels = parseInt(msg.MexChannels);
    for (var i = 0; i < mexChannels; i++) {
      var newMsg = {
        State: msg["MexState_".concat(i)],
        UniqueID: msg["MexUniqueID_".concat(i)],
        CallID: msg["MexCallID_".concat(i)],
        CallerID: msg["MexCallerID_".concat(i)],
        type: 'mex',
        Starttime: msg["MexStarttime_".concat(i)],
        AnsweredTime: msg["MexAnsweredTime_".concat(i)],
        MexUser: msg.MexUser,
        Direction: msg["MexDirection_".concat(i)],
        Queuename: msg["MexQueuename_".concat(i)],
        OriginalCallerID: msg["MexOriginalCallerID_".concat(i)]
      };
      dispatch(receiveNewMexChannel(newMsg));
    }
  };
};
export var receiveExtension = function receiveExtension(msg) {
  var isEventExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    dispatch({
      type: Actions.RESULT_TOP_EXTENSION,
      data: msg
    });
    if (msg.ActiveProfile) {
      dispatch(receiveActiveProfile(msg));
    }
    if (msg.UniqueID) {
      dispatch(receiveNewChannel(msg, isEventExtension));
    }
    if (msg.MexChannels && parseInt(msg.MexChannels) > 0) {
      dispatch(recieveNewMexChannelsOnSync(msg));
    }
    if (msg.CoMonitoringSupervisorCount && parseInt(msg.CoMonitoringSupervisorCount, 10) > 0) {
      var entityKey = findEntityKey(getState, msg);
      if (!entityKey && appConfig.environment === 'dev') {
        console.warn('Failed to locate entity key for colistening during sync', msg);
      }
      var callKey = 'activecall-' + msg.UniqueID;
      var supervisorCount = parseInt(msg.CoMonitoringSupervisorCount, 10);
      for (var i = 0; i < supervisorCount; i++) {
        var uniqueIdString = 'CoMonitoringSupervisor_' + i + '_UniqueID';
        var entityKeyString = 'CoMonitoringSupervisor_' + i + '_EntityKey';
        var supervisorUniqueId = msg[uniqueIdString];
        var supervisorEntityKey = msg[entityKeyString];
        dispatch(addCoListener(entityKey, callKey, supervisorEntityKey, supervisorUniqueId));
      }
    }
  };
};
export var receiveLink = function receiveLink(msg) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      app = _getState2.app;
    var extensionKey = findEntityKey(getState, msg);
    var activeCallEntityKey = 'activecall-' + msg.UniqueID;
    if (!extensionKey) {
      return;
    }
    if (isAppCti(getState())) {
      dispatch(callAnswered(activeCallEntityKey));
    }
    var parkChannelDTO = {
      channelName: msg.Channel,
      parkChannelName: msg.LinkName,
      parkerPhoneNumber: app.getIn(['extension', 'topRouteKey'])
    };
    dispatch({
      type: Actions.EXTENSION_UPDATE_ACTIVE_CALL_PARK_DTO,
      activeCallEntityKey: activeCallEntityKey,
      extensionKey: extensionKey,
      data: parkChannelDTO
    });
    dispatch(handleAutoCoListenAlphaFeatureOnCallEstablished(msg.UniqueID));
  };
};

/**
 * TOP sends AnsweredTime (epoch ms) when it knows when the channel went Up,
 * also in the sync snapshot for calls that were ongoing when we connected.
 * Older TOP versions don't send it, so fall back to stamping a live 'Up'.
 */
var getAnsweredTime = function getAnsweredTime(msg) {
  if (msg.AnsweredTime) {
    return parseInt(msg.AnsweredTime);
  }
  if (msg.Event === 'NewState' && msg.State === 'Up') {
    return moment().valueOf();
  }
  return undefined;
};
var findEntityKey = function findEntityKey(getState, msg) {
  var _getState3 = getState(),
    top = _getState3.top;
  return top.getIn(['uniqueIdToEntityKey', msg.UniqueID]);
};
var findEntityKeyByDownName = function findEntityKeyByDownName(getState, downName) {
  var _getState4 = getState(),
    top = _getState4.top;
  return top.getIn(['prefixToEntityKey', downName]);
};
export var receiveHangup = function receiveHangup(msg) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
      top = _getState5.top;
    var entityKey = findEntityKey(getState, msg);
    ctiTraceLog(getState(), "receiveHangup entityKey: ".concat(entityKey), msg.LocutusSessionId);
    if (entityKey) {
      var activeCallKey = "activecall-".concat(msg.UniqueID);
      var activeCall = {
        state: 'down',
        key: activeCallKey
      };
      if (isAppCti(getState())) {
        var LocutusSessionId = msg.LocutusSessionId;
        ctiTraceLog(getState(), "dispatch callHungup: ".concat(activeCall.key), LocutusSessionId);
        dispatch(callHungup(activeCall.key, LocutusSessionId));
      }
      if (loggedInUserHasOmnichannelFeature(getState())) {
        dispatch(removeOmnichannelDeeplink(msg.UniqueID));
      }

      // For remote calls we need to re-render the call item in the down-state when hanging up in order for "call ended" to display properly.
      // Without the zero second timeout on removeActiveCall this wouldn't happen while the call is active, and after that we can't render the call item anymore.
      dispatch(addOrUpdateActiveCall(entityKey, activeCall));
      setTimeout(function () {
        dispatch(removeActiveCall(entityKey, activeCall));
        // Once the call is out of the active list, any companion mute we remembered for it is
        // dead. Done here rather than in the call component because whoever hung up - this
        // surface, the companion or the far end - the component may never render the down
        // state above before it unmounts.
        dispatch(sweepCompanionMuteState());
      }, 0);
    } else if (appConfig.environment === 'dev') {
      console.warn('Failed to locate entity key', msg);
    }
    var channel = top.getIn(['uniqueIdToChannel', msg.UniqueID], Map());
    if (channel) {
      var callId = channel.get('CallID');
      var isActiveMeetingCall = callId === selectActiveMeetingCallId(getState());
      if (isActiveMeetingCall) {
        dispatch(endMeeting());
      }
    }
    if (channel && channel.has('Queuename')) {
      msg.Queue = channel.get('Queuename').replace('_', '-');
    }
    dispatch({
      type: Actions.RESULT_TOP_HANGUP_CHANNEL,
      data: msg
    });
  };
};
var updateActiveCall = function updateActiveCall(msg) {
  var isEventExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    var entityKey = findEntityKey(getState, msg);
    if (entityKey) {
      var activeCall = {
        state: msg.State ? msg.State.toLowerCase() : '',
        key: 'activecall-' + msg.UniqueID
      };
      if (msg.CallID) {
        activeCall.callId = msg.CallID;
      }
      var isDestination = (msg === null || msg === void 0 ? void 0 : msg.Direction) === 'in';
      /**
       * Related Issue: #WEB-15078
       */
      var isExtensionSource = isEventExtension ? !isDestination : true;

      // The 'NewChannel' event usually has CallerID
      if (msg.CallerID && isExtensionSource) {
        activeCall.source = convertNumberToE164(msg.CallerID);
      }
      // 'type' is set manually to 'mex' when receiving 'MexIn'- and 'Mexout' events,
      // to match the Home API.
      if (msg.type) {
        activeCall.type = msg.type;
      }
      var answeredTime = getAnsweredTime(msg);
      if (answeredTime) {
        activeCall.answeredTime = answeredTime;
      }
      if (msg.Starttime) {
        activeCall.startTime = parseInt(msg.Starttime);
      }
      // The event 'NumberInfo' has 'Direction'. It's also set manually
      // when receiving the 'MexIn'- and 'MexOut' events to match the ActiveCallDTO
      // in the Home API.
      if (msg.Direction) {
        activeCall.direction = formatDirection(msg.Direction);
      }
      if ('isOmnichannelErrand' in msg) {
        activeCall.isOmnichannelErrand = msg.isOmnichannelErrand;
      }
      if ('isTelavoxTicketNonCall' in msg) {
        activeCall.isTelavoxTicketNonCall = msg.isTelavoxTicketNonCall;
      }
      if (msg.Queuename && msg.OriginalCallerID) {
        activeCall.originalCallerId = msg.OriginalCallerID;
      }
      if (shouldAutoOpenCallWidgetUrls(getState(), activeCall)) {
        dispatch(tryAutoOpenWidgetUrls(activeCall));
      }
      dispatch(addOrUpdateActiveCall(entityKey, activeCall));
    } else if (appConfig.environment === 'dev') {
      console.warn('Failed to locate entity key', msg);
    }
  };
};
export var addBagVariablesFromNewChannelMessage = function addBagVariablesFromNewChannelMessage(msg) {
  return function (dispatch, getState) {
    var UniqueID = msg.UniqueID;
    if (msg.VariableCount) {
      try {
        var count = parseInt(msg.VariableCount);
        for (var i = 0; i < count; i++) {
          var name = msg["VariableName".concat(i)];
          var value = msg["VariableValue".concat(i)];
          var decodedValue = atob(value);
          var entityKey = findEntityKey(getState, msg);
          var callKey = "activecall-".concat(UniqueID);
          dispatch(addBagVariable(entityKey, callKey, name, decodedValue));
        }
      } catch (_error) {
        /* noop */
      }
    }
  };
};
export var receiveNewChannel = function receiveNewChannel(msg) {
  var isEventExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    var UniqueID = msg.UniqueID,
      Queuename = msg.Queuename,
      State = msg.State;
    if (!UniqueID) {
      return;
    }
    msg.isTelavoxTicketNonCall = !!getDataFromBagInTopMessage(msg, 'telavox.omni.ticket');

    //IMPORTANT: if there is a bag variable with cention data, the channel received is a cention errand, not a phone call
    msg.isOmnichannelErrand = !!getBagVariableCentionMessageFromTopMessage(msg);
    // Sometimes the "NewChannel" event comes in with the
    // CallerID set to '<unknown>'.
    // We don't want to overwrite a number with this string
    // in the merge.
    if (msg.CallerID === UNKNOWN_CALLER_ID) {
      delete msg.CallerID;
    }

    /**
     * We discovered that when answering a queue call, Direction is 'unknown'.
     * We don't want to override the existing direction with 'unknown', so we simply ignore it.
     */
    if (msg.Direction === 'unknown') {
      delete msg.Direction;
    }
    if (msg.AnsweredTime) {
      msg.answeredTime = parseInt(msg.AnsweredTime);
    }
    dispatch(updateTopChannel(msg, UniqueID));
    if (Queuename) {
      var queueKey = Queuename.replace('_', '-');
      dispatch(setTopQueueCall(UniqueID, queueKey, State));
      dispatch(rememberQueueCallForChannel(UniqueID, queueKey));
    }
    dispatch({
      type: Actions.RESULT_TOP_NEW_CHANNEL,
      data: msg
    });
    dispatch(updateActiveCall(msg, isEventExtension));
    dispatch(addBagVariablesFromNewChannelMessage(msg));
  };
};
export var receiveNewState = function receiveNewState(msg) {
  return function (dispatch, getState) {
    var _getState6 = getState(),
      top = _getState6.top;
    var UniqueID = msg.UniqueID,
      State = msg.State;
    if (State === 'Up') {
      msg.answeredTime = getAnsweredTime(msg);
    }
    dispatch(updateTopChannel(msg, UniqueID));
    var queueName = top.getIn(['uniqueIdToChannel', UniqueID], Map()).get('Queuename');
    if (queueName) {
      var queueKey = queueName.replace('_', '-');
      dispatch(setTopQueueCall(UniqueID, queueKey, State));
      dispatch(rememberQueueCallForChannel(UniqueID, queueKey));
    }
    dispatch(updateActiveCall(msg));
  };
};
export var receiveMexIn = function receiveMexIn(msg) {
  return function (dispatch) {
    dispatch(receiveNewMexChannel(_objectSpread(_objectSpread({}, msg), {}, {
      type: 'mex',
      Direction: 'Incoming'
    })));
  };
};
export var receiveMexOut = function receiveMexOut(msg) {
  return function (dispatch) {
    dispatch(receiveNewMexChannel(_objectSpread(_objectSpread({}, msg), {}, {
      type: 'mex',
      Direction: 'Outgoing'
    })));
  };
};
export var receiveNewMexChannel = function receiveNewMexChannel(msg) {
  return function (dispatch) {
    dispatch({
      type: Actions.RESULT_TOP_NEW_MEX_CHANNEL,
      data: msg
    });
    dispatch(updateActiveCall(msg));
  };
};
export var receiveGoAway = function receiveGoAway(dispatch) {
  dispatch(unregisterTopConnection);
};
export var unregisterTopConnection = {
  type: Actions.UNREGISTER_TOP_CONNECTION
};
export var hangupCall = function hangupCall(entityKey) {
  if (!isActiveCallKey(entityKey)) {
    return;
  }
  var uniqueId = getIdFromEntityKey(entityKey);
  topHangupCall(uniqueId);
};

// Queue items are stored for every queue top reports. Filtering to the queues
// in the user's filter happens on read, not here: pbx.queues is fetched over
// REST in parallel with the top connection, so a write-time filter would
// silently drop the whole sync snapshot whenever the snapshot won first.
export var receiveQueueMembers = function receiveQueueMembers(eventsByQueue) {
  return function (dispatch) {
    var _iterator = _createForOfIteratorHelper(eventsByQueue.entries()),
      _step;
    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
          queue = _step$value[0],
          events = _step$value[1];
        var queueEntityKey = parseTopKey(queue);

        // Sort events based on position. There is a bug in top where the positions are not always correct,
        // so if the position is the same for two objects we sort based on jointime instead
        events.sort(function (a, b) {
          var aPos = Number(a.Position);
          var bPos = Number(b.Position);
          if (aPos !== bPos) {
            return aPos - bPos;
          }
          return Number(a.Jointime) - Number(b.Jointime);
        });
        var queueCallDTOs = events.map(function (event) {
          var queueCallKey = "queuecall-".concat(queueEntityKey, "-").concat(event.QueueID);
          var number = convertNumberToE164(event.OriginalCallerID);
          var isCentionErrand = topEventHasChannelOfTypeCentionOmni(event);
          var telavoxTicketId = getDataFromBagInTopMessage(event, 'telavox.omni.ticket_id');
          var telavoxTicketNonCallData = getDataFromBagInTopMessage(event, 'telavox.omni.ticket');
          var centionErrandData = getBagVariableCentionMessageFromTopMessage(event);
          return _objectSpread(_objectSpread({
            key: queueCallKey,
            queueEntityKey: queueEntityKey,
            entryId: event.QueueID,
            caller: {
              number: number
            },
            joinTime: moment.unix(event.Jointime).format(ISO_8601_MS_RESOLUTION),
            isTelavoxTicketNonCall: !!telavoxTicketNonCallData,
            telavoxOmniTicketId: telavoxTicketId,
            isOmnichannelErrand: isCentionErrand,
            locutusSessionId: event.LocutusSessionId
          }, telavoxTicketNonCallData && {
            telavoxOmniTicketData: _objectSpread({}, telavoxTicketNonCallData)
          }), centionErrandData && {
            omnichannelErrandDeepLinkId: centionErrandData.deepLink,
            omnichannelErrandChannelType: centionErrandData.channel,
            omnichannelErrandUserFriendlyDescription: centionErrandData.humanReadableDesc,
            omnichannelErrandSender: centionErrandData.fromUser
          });
        });
        dispatch(addPendingQueueItems(queueEntityKey, queueCallDTOs));
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
};
export var receiveQueueJoinEvent = function receiveQueueJoinEvent(msg) {
  return function (dispatch) {
    var queueEntityKey = parseTopKey(msg.Queue);
    var queueCallKey = "queuecall-".concat(queueEntityKey, "-").concat(msg.QueueID);
    var number = convertNumberToE164(msg.OriginalCallerID);
    var isCentionErrand = topEventHasChannelOfTypeCentionOmni(msg);
    var telavoxTicketId = getDataFromBagInTopMessage(msg, 'telavox.omni.ticket_id');
    var telavoxTicketNonCallData = getDataFromBagInTopMessage(msg, 'telavox.omni.ticket');
    var centionErrandData = getBagVariableCentionMessageFromTopMessage(msg);
    var queueCallDTO = _objectSpread(_objectSpread({
      key: queueCallKey,
      queueEntityKey: queueEntityKey,
      entryId: msg.QueueID,
      caller: {
        number: number
      },
      joinTime: moment.unix(msg.Jointime).format(ISO_8601_MS_RESOLUTION),
      isTelavoxTicketNonCall: !!telavoxTicketNonCallData,
      telavoxOmniTicketId: telavoxTicketId,
      isOmnichannelErrand: isCentionErrand,
      locutusSessionId: msg.LocutusSessionId
    }, telavoxTicketNonCallData && {
      telavoxOmniTicketData: _objectSpread({}, telavoxTicketNonCallData)
    }), centionErrandData && {
      omnichannelErrandDeepLinkId: centionErrandData.deepLink,
      omnichannelErrandChannelType: centionErrandData.channel,
      omnichannelErrandUserFriendlyDescription: centionErrandData.humanReadableDesc,
      omnichannelErrandSender: centionErrandData.fromUser
    });
    dispatch(addPendingQueueItem(queueEntityKey, queueCallDTO, queueCallKey, msg.Position));
  };
};

// Ties a channel joining a queue's ongoing calls to the call record the queue call
// becomes and the time it joined, so the queue's history can be brought up to date
// once the call is over.
//
// The channels carrying a queue name are the agent legs the call rings out to, not
// the caller's own channel, so the two halves have to be matched on the caller's
// number. Done as the channel joins rather than as it leaves, since the hangup takes
// the channel's details with it.
var rememberQueueCallForChannel = function rememberQueueCallForChannel(channelID, queueKey) {
  return function (dispatch, getState) {
    var callerNumber = getState().top.getIn(['uniqueIdToChannel', channelID, 'OriginalCallerID']);
    if (!callerNumber) return;
    var waitingQueueCall = selectWaitingQueueCallForCaller(getState(), queueKey, convertNumberToE164(callerNumber));
    if (!waitingQueueCall) return;

    // Not every SIP server sends us the locutus session yet, so the call record
    // isn't always known. The join time alone still tells the history fetch how
    // far back to reach; it just has nothing specific to wait for.
    var locutusSessionId = waitingQueueCall.get('locutusSessionId');
    dispatch({
      type: Actions.SET_QUEUE_CALL_FOR_CHANNEL,
      channelID: channelID,
      queueKey: queueKey,
      callRecordKey: locutusSessionId ? "call-".concat(locutusSessionId) : undefined,
      queueJoinTime: waitingQueueCall.get('joinTime')
    });
  };
};

// Top's leave reason when an agent picked the call up. The other reasons
// (Abandon, Timeout, Digit, Empty, Full) all mean the call is over.
var QUEUE_LEAVE_REASON_ANSWERED = 'Answer';
export var receiveQueueLeaveEvent = function receiveQueueLeaveEvent(msg) {
  return function (dispatch, getState) {
    var queueEntityKey = parseTopKey(msg.Queue);
    var queueCallKey = "queuecall-".concat(queueEntityKey, "-").concat(msg.QueueID);
    var waitingQueueItem = selectWaitingQueueItem(getState(), queueCallKey);
    var joinTime = waitingQueueItem === null || waitingQueueItem === void 0 ? void 0 : waitingQueueItem.get('joinTime');
    // The leave event carries the locutus session of the queue call, which is the
    // key of the call record the call ends up as. Fall back to the session we were
    // given when the item joined the queue.
    var locutusSessionId = msg.LocutusSessionId || (waitingQueueItem === null || waitingQueueItem === void 0 ? void 0 : waitingQueueItem.get('locutusSessionId'));
    var callRecordKey = locutusSessionId ? "call-".concat(locutusSessionId) : undefined;
    var itemIsNotACall = !!(waitingQueueItem !== null && waitingQueueItem !== void 0 && waitingQueueItem.get('isOmnichannelErrand')) || !!(waitingQueueItem !== null && waitingQueueItem !== void 0 && waitingQueueItem.get('isTelavoxTicketNonCall'));
    dispatch(removeWaitingQueueItem(queueEntityKey, queueCallKey));
    dispatch(updateWaitingQueueItemPositions(queueEntityKey));
    dispatch(onQueueLeaveForMissedCallsWidget(queueEntityKey, joinTime, msg === null || msg === void 0 ? void 0 : msg.LeaveReason));

    // A call picked up by an agent isn't over: it carries on as an ordinary channel
    // and reaches the history when that channel hangs up, off what we remembered
    // when it joined the queue.
    if ((msg === null || msg === void 0 ? void 0 : msg.LeaveReason) === QUEUE_LEAVE_REASON_ANSWERED) return;

    // A queue item that isn't a call -- a Cention errand, or a ticket that isn't one
    // -- never becomes a call record, so the queue's call history has nothing to
    // gain from it ending.
    if (itemIsNotACall) return;

    // Every other reason (abandoned, timed out, left with a digit, queue empty or
    // full) means the call is over and its record belongs in the history now.
    dispatch(onQueueCallEnded(queueEntityKey, callRecordKey, joinTime));
  };
};
var onQueueLeaveForMissedCallsWidget = function onQueueLeaveForMissedCallsWidget(queueEntityKey, joinTime, leaveReason) {
  return function (dispatch, getState) {
    var _selectQueueFavorites;
    if (!selectMissedCallsWidgetIsMounted(getState())) return;
    if (leaveReason !== 'Abandon') return;

    // To be modified if we add the option for the user to toggle calls from favorites only on/off
    // (currently it is for favorites only)
    var callWasInFavoriteQueue = (_selectQueueFavorites = selectQueueFavorites(getState())) === null || _selectQueueFavorites === void 0 ? void 0 : _selectQueueFavorites.find(function (favorite) {
      return (favorite === null || favorite === void 0 ? void 0 : favorite.getIn(['favoriteData', 'key'])) === queueEntityKey;
    });
    if (!callWasInFavoriteQueue) return;
    var since = joinTime ? moment(joinTime).subtract(15, 'seconds').valueOf() : moment().subtract(1, 'hour').valueOf();
    // If joinTime is found, we fetch call records from the queue between that point in time (minus 15 seconds) and now.
    // If joinTime for some reason is not found, we fall back to fetching from last hour.

    dispatch(fetchQueueCallRecordsUnhandled(true, false, undefined, since));
  };
};
var addPendingQueueItems = function addPendingQueueItems(queueKey, queueCalls) {
  return {
    type: Actions.RESULT_TOP_WAITING_QUEUE_ITEMS_ADD,
    queueKey: queueKey,
    queueCalls: queueCalls
  };
};
var addPendingQueueItem = function addPendingQueueItem(queueKey, queueCall, queueCallKey, position) {
  return {
    type: Actions.RESULT_TOP_WAITING_QUEUE_ITEM_ADD,
    queueKey: queueKey,
    queueCall: queueCall,
    queueCallKey: queueCallKey,
    position: Number(position)
  };
};
var removeWaitingQueueItem = function removeWaitingQueueItem(queueKey, queueCallKey) {
  return {
    type: Actions.RESULT_TOP_WAITING_QUEUE_ITEM_REMOVE,
    queueKey: queueKey,
    queueCallKey: queueCallKey
  };
};
var updateWaitingQueueItemPositions = function updateWaitingQueueItemPositions(queueKey) {
  return {
    type: Actions.UPDATE_WAITING_QUEUE_CALL_ORDER,
    queueKey: queueKey
  };
};
export var receiveQueueAgentActivity = function receiveQueueAgentActivity(msg, loggedIn) {
  return function (dispatch, getState) {
    var _getState7 = getState(),
      top = _getState7.top,
      pbx = _getState7.pbx;
    var extensionKey = top.getIn(['anumberToEntityKey', msg.Anumber]);

    /**
     * It this an colleague in my operator group?
     */

    if (extensionKey) {
      var queuememberKey = "queuemember-".concat(getIdFromEntityKey(extensionKey));
      var queueEntityKey = parseTopKey(msg.Queue);

      /**
       * It the queue part of my operator group?
       */

      if (pbx.hasIn(['queues', queueEntityKey])) {
        var queueMemberDTO = {
          key: queuememberKey,
          loggedIn: loggedIn
        };
        dispatch(receiveQueueMemberUpdate(queueEntityKey, queuememberKey, queueMemberDTO));
      }
    }
  };
};
export var receiveNumberInfo = function receiveNumberInfo(msg) {
  return function (dispatch, getState) {
    var entityKey = findEntityKey(getState, msg);
    var extensionKey = getOwnExtensionKey(getState());

    // Swedish numbers from Top are generally on a local format (no
    // international prefix, nor a country calling code).
    // Non-Swedish number from Top generally have an ITU-prefix ('00') and a
    // country calling code (e.g. '45').

    // Normalised on entry rather than at the write below, so that no consumer
    // of the stored call has to know about the sentinel - the same thing
    // 'receiveNewChannel' does for 'CallerID'.
    var source = msg.Source === UNKNOWN_CALLER_ID ? undefined : msg.Source;
    var e164Source = convertNumberToE164(source);
    var e164Destination = convertNumberToE164(msg.Destination);
    var activeCall = _objectSpread(_objectSpread({
      key: "activecall-".concat(msg.UniqueID),
      destination: e164Destination
    }, e164Source && {
      source: e164Source
    }), {}, {
      direction: formatDirection(msg.Direction),
      rdnis: msg.Rdnis,
      locutusSessionId: msg.LocutusSessionId
    }, msg.Queue && {
      queue: parseTopKey(msg.Queue)
    });
    dispatch(updateTopChannel(msg, msg.UniqueID));
    if (entityKey !== extensionKey) {
      // Need to know the destination of the call to determine mobile
      // or fixed call to colleague for the pickup call functionality
      dispatch(addOrUpdateActiveCall(entityKey, activeCall));
      return;
    }
    dispatch(addOrUpdateActiveCall(entityKey, activeCall));
    if (isAppCti(getState()) && !msg.Queue) {
      dispatch(handleNewCall(activeCall.key));
    }
  };
};
export var receiveUpdateCallerID = function receiveUpdateCallerID(msg) {
  return function (dispatch, getState) {
    if (!msg.CallerID) {
      return;
    }
    var entityKey = findEntityKey(getState, msg);
    if (entityKey) {
      var activeCall = {
        key: "activecall-".concat(msg.UniqueID),
        source: convertNumberToE164(msg.CallerID)
      };
      dispatch(addOrUpdateActiveCall(entityKey, activeCall));
    }
  };
};
export var sendPickupQueue = function sendPickupQueue(callKey) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown position';
  return function (_dispatch, getState) {
    var queueItem = selectWaitingQueueItem(getState(), callKey);
    var topFormatedNumberToCall = formatE164NumberToTopFriendly(getOwnFixedNumber(getState()) || getOwnMobileNumber(getState()) || '');
    var queueName = getState().pbx.getIn(['queues', queueItem.get('queueEntityKey'), 'description'], 'Unknown queue');
    var queue = queueItem.get('queueEntityKey').replace('-', '_');
    var queueId = queueItem.get('entryId');
    pickupQueueCall(queue, queueId, topFormatedNumberToCall);
    addUserPhoneLogEntry("User picked queue call from caller: ".concat(queueItem.getIn(['caller', 'number']), " in queue: ").concat(queueName, " from ").concat(position));
  };
};
export var sendPickupCall = function sendPickupCall() {
  return function (_dispatch, getState) {
    var topFormatedNumberToCall = formatE164NumberToTopFriendly(getOwnFixedNumber(getState()) || getOwnMobileNumber(getState()) || '');
    var ringingCall = getRingingCall(getState());
    var ringingCallId = ringingCall.get('key', '').replace('activecall-', '');
    pickupCall(ringingCallId, topFormatedNumberToCall);
  };
};
export var mergeCall = function mergeCall() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var localActiveCalls, sortedByDate, uniqueIds, uniqueIdToKeep, uniqueIdsToMerge, uniqueIdsToMergeString, result, localSessions, ownExtensionKey, callKey, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            localActiveCalls = getLocalActiveCalls(getState());
            if (!(localActiveCalls.size <= 1)) {
              _context.next = 1;
              break;
            }
            addTopLogEntry('Only had one active call when trying to merge');
            return _context.abrupt("return");
          case 1:
            sortedByDate = localActiveCalls.sort(function (a, b) {
              return a.get('startTime') - b.get('startTime');
            });
            uniqueIds = sortedByDate.map(function (call) {
              return call.get('key', '').replace('activecall-', '');
            });
            uniqueIdToKeep = uniqueIds.get(0);
            uniqueIdsToMerge = uniqueIds.slice(1);
            if (!(uniqueIdsToMerge && uniqueIdsToMerge.size >= 1 && uniqueIdsToMerge.some(function (id) {
              return id === '';
            }))) {
              _context.next = 2;
              break;
            }
            addTopLogEntry("One or more of the ids to merge into the call were empty. Active local calls: \n\n ".concat(localActiveCalls.toJS()));
            return _context.abrupt("return");
          case 2:
            uniqueIdsToMergeString = uniqueIdsToMerge.join();
            addTopLogEntry("Merging uniqueIds ".concat(uniqueIdsToMergeString, " into ").concat(uniqueIdToKeep));
            _context.prev = 3;
            _context.next = 4;
            return mergeIntoConference(uniqueIdToKeep, uniqueIdsToMergeString);
          case 4:
            result = _context.sent;
            localSessions = getLocalCallSessions(getState());
            unholdAllSessions(localSessions);
            ownExtensionKey = getOwnExtensionKey(getState());
            callKey = 'activecall-' + uniqueIdToKeep;
            dispatch(callMergedIntoConference(ownExtensionKey, callKey, result.MeetingCode));
            _context.next = 6;
            break;
          case 5:
            _context.prev = 5;
            _t = _context["catch"](3);
            addTopLogEntry('Failed to merge calls, error: ', _t);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 5]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var formatDirection = function formatDirection(direction) {
  switch (direction) {
    case ActiveCallDirections.OUTGOING.value:
    case ActiveCallDirections.INCOMING.value:
      return direction;
    case 'out':
    case 'Outgoing':
    case 'outgoing':
      return ActiveCallDirections.OUTGOING.value;
    case 'in':
    case 'Incoming':
    case 'incoming':
      return ActiveCallDirections.INCOMING.value;
    default:
      return direction;
  }
};
var parseTopKey = function parseTopKey(key) {
  return key && key.replace('_', '-');
};
export var receiveQueueCallInfo = function receiveQueueCallInfo(msg) {
  return function (dispatch, getState) {
    var UniqueID = msg.UniqueID;
    if (!UniqueID) {
      return;
    }
    dispatch(updateTopChannel(msg, UniqueID));

    /* --- Update current active call as before --- */
    var extensionKey = findEntityKey(getState, msg);
    var ownExtensionKey = getOwnExtensionKey(getState());
    if (extensionKey !== ownExtensionKey) {
      return;
    }
    var activeCall = _objectSpread({
      key: 'activecall-' + msg.UniqueID
    }, msg.OriginalRdnis && {
      originalRdnis: msg.OriginalRdnis
    });
    if (msg.OriginalCallerID && msg.OriginalCallerID !== UNKNOWN_CALLER_ID) {
      activeCall.source = convertNumberToE164(msg.OriginalCallerID);
    }

    // Only set the name when the event has one. Assigning it unconditionally
    // would store 'queueName: undefined', which the reducer merges over any
    // name an earlier event stored (Top sends one of these events per queue
    // when a call is picked from another queue).
    if (msg.Description) {
      activeCall.queueName = msg.Description;
    }
    dispatch(addOrUpdateActiveCall(extensionKey, activeCall));
    if (shouldAutoOpenCallWidgetUrlsForPickedQueueCall(getState(), activeCall)) {
      dispatch(tryAutoOpenWidgetUrls(activeCall));
    }
    if (isAppCti(getState())) {
      dispatch(handleNewCall(activeCall.key));
    }
  };
};
export var updateTopChannel = function updateTopChannel(channel, channelID) {
  return {
    type: Actions.UPDATE_TOP_CHANNEL,
    channel: channel,
    channelID: channelID
  };
};
var setTopQueueCall = function setTopQueueCall(channelID, queue, state) {
  return {
    type: Actions.SET_TOP_QUEUE_CALL,
    channelID: channelID,
    queue: queue,
    state: state
  };
};
export var clearTopQueueCalls = function clearTopQueueCalls() {
  return {
    type: Actions.CLEAR_TOP_QUEUE_CALLS
  };
};

// A bag variable is a variable set in a customer specific routing script
// that can be used on our side to attach to an external search URL,
// E.G. input of an order id in an IVR.
export var receiveBagVariable = function receiveBagVariable(msg) {
  return function (dispatch, getState) {
    var UniqueID = msg.UniqueID,
      VariableName = msg.VariableName,
      VariableValue = msg.VariableValue;
    if (!UniqueID || !VariableName || !VariableValue) {
      return;
    }
    var entityKey = findEntityKey(getState, msg);
    if (entityKey) {
      var callKey = 'activecall-' + UniqueID;
      var decodedValue = base64DecodeUTF8(VariableValue);
      var shouldRedecorate = isAppCti(getState()) && isBagVariableChanged(getState(), entityKey, callKey, VariableName, decodedValue);
      dispatch(addBagVariable(entityKey, callKey, VariableName, decodedValue));
      if (shouldRedecorate) {
        dispatch(redecorateCall(callKey));
      }
    } else if (appConfig.environment === 'dev') {
      console.warn('Failed to locate entity key when setting bag variable', msg);
    }
  };
};
var addBagVariable = function addBagVariable(extensionKey, callKey, variableName, variableValue) {
  return {
    type: Actions.EXTENSION_UPDATE_ACTIVE_CALL_BAG_VARIABLE,
    extensionKey: extensionKey,
    callKey: callKey,
    variableName: variableName,
    variableValue: variableValue
  };
};
export var receiveCoMonitoredStart = function receiveCoMonitoredStart(msg) {
  return function (dispatch, getState) {
    var UniqueID = msg.UniqueID,
      SupervisorEntityKey = msg.SupervisorEntityKey,
      SupervisorUniqueID = msg.SupervisorUniqueID;
    if (!UniqueID || !SupervisorEntityKey || !SupervisorUniqueID) {
      return;
    }
    var entityKey = findEntityKey(getState, msg);
    if (entityKey) {
      var callKey = 'activecall-' + UniqueID;
      dispatch(addCoListener(entityKey, callKey, SupervisorEntityKey, SupervisorUniqueID));
    } else if (appConfig.environment === 'dev') {
      console.warn('Failed to locate entity key when receiving colistening start', msg);
    }
  };
};
var addCoListener = function addCoListener(extensionKey, callKey, supervisorExtensionKey, supervisorUniqueId) {
  return {
    type: Actions.EXTENSION_COLISTENING_ADD_LISTENER,
    extensionKey: extensionKey,
    callKey: callKey,
    supervisorExtensionKey: supervisorExtensionKey,
    supervisorUniqueId: supervisorUniqueId
  };
};
export var receiveCoMonitoredEnd = function receiveCoMonitoredEnd(msg) {
  return function (dispatch, getState) {
    var UniqueID = msg.UniqueID,
      SupervisorUniqueID = msg.SupervisorUniqueID;
    if (!UniqueID || !SupervisorUniqueID) {
      return;
    }
    var entityKey = findEntityKey(getState, msg);
    if (entityKey) {
      var callKey = 'activecall-' + UniqueID;
      dispatch(removeCoListener(entityKey, callKey, SupervisorUniqueID));
    } else if (appConfig.environment === 'dev') {
      console.warn('Failed to locate entity key when receiving colistening stop', msg);
    }
  };
};
var removeCoListener = function removeCoListener(extensionKey, callKey, supervisorUniqueId) {
  return {
    type: Actions.EXTENSION_COLISTENING_REMOVE_LISTENER,
    extensionKey: extensionKey,
    callKey: callKey,
    supervisorUniqueId: supervisorUniqueId
  };
};
export var receiveAttendedTransferCancelled = function receiveAttendedTransferCancelled(msg) {
  return function (dispatch) {
    dispatch(resolveTransferPending(msg.UniqueID, 'AttendedTransferCancelled received from top'));
  };
};
export var receiveExternalChannel = function receiveExternalChannel(msg) {
  return function (dispatch, getState) {
    var DownName = msg.DownName;
    var extensionKey = findEntityKeyByDownName(getState, DownName);
    var externalChannel = {
      channel: msg.Channel
    };
    if (msg.Busy === 'true') {
      dispatch({
        type: Actions.EXTENSION_SET_EXTERNAL_CHANNEL,
        data: externalChannel,
        extensionKey: extensionKey
      });
    } else {
      dispatch({
        type: Actions.EXTENSION_REMOVE_EXTERNAL_CHANNEL,
        data: externalChannel,
        extensionKey: extensionKey
      });
    }
  };
};
export var receiveMergedIntoConference = function receiveMergedIntoConference(msg) {
  return function (dispatch, getState) {
    var UniqueID = msg.UniqueID,
      MeetingCode = msg.MeetingCode;
    if (!UniqueID || !MeetingCode) {
      addTopLogEntry('Received incomplete MergedIntoConference event: ', msg);
      return;
    }
    var entityKey = findEntityKey(getState, msg);
    if (entityKey) {
      var callKey = 'activecall-' + UniqueID;
      dispatch(callMergedIntoConference(entityKey, callKey, MeetingCode));
    } else if (appConfig.environment === 'dev') {
      console.warn('Failed to locate entity key when receiving merge into conference event', msg);
    }
  };
};
export var onTopEventCallRecordingTranscriptionProgress = function onTopEventCallRecordingTranscriptionProgress(msg) {
  return function (dispatch) {
    var recordedCallKey = msg.data.recordedCallId;
    var transcriptionState = msg.data.transcriptionState;
    dispatch(setTranscriptionInProgress(recordedCallKey, transcriptionState));
  };
};
var callMergedIntoConference = function callMergedIntoConference(extensionKey, callKey, meetingCode) {
  return {
    type: Actions.EXTENSION_CALL_MERGED_INTO_CONFERENCE,
    extensionKey: extensionKey,
    callKey: callKey,
    meetingCode: meetingCode
  };
};